module.exports = __webpack_public_path__ + "img/xingbake.291fb3b5.png";